/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetingLocation } from '../../models/meeting-location';

export interface GetAllMeetingLocations$Json$Params {
}

export function getAllMeetingLocations$Json(http: HttpClient, rootUrl: string, params?: GetAllMeetingLocations$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MeetingLocation>>> {
  const rb = new RequestBuilder(rootUrl, getAllMeetingLocations$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MeetingLocation>>;
    })
  );
}

getAllMeetingLocations$Json.PATH = '/api/MeetingLocation';
